import { httpClient } from "./httpClient";

const base = "/api/empleados";

export const listarEmpleados = (params = {}) => {
  const query = new URLSearchParams(
    Object.fromEntries(Object.entries(params).filter(([, v]) => v && v !== "all"))
  ).toString();
  return httpClient.get(query ? `${base}?${query}` : base);
};

export const obtenerEmpleado  = (id)      => httpClient.get(`${base}/${id}`);
export const crearEmpleado    = (datos)   => httpClient.post(base, datos);
export const actualizarEmpleado = (id, datos) => httpClient.put(`${base}/${id}`, datos);
export const darDeBajaEmpleado  = (id)    => httpClient.delete(`${base}/${id}`);
export const listarPuestos           = ()        => httpClient.get(`${base}/puestos`);
export const docentesDisponibles     = ()        => httpClient.get(`${base}/docentes-disponibles`);
export const importarDesdeDocentes   = (docentes) => httpClient.post(`${base}/importar-docentes`, { docentes });

const empleadosService = {
  listar: listarEmpleados,
  obtener: obtenerEmpleado,
  crear: crearEmpleado,
  actualizar: actualizarEmpleado,
  darDeBaja: darDeBajaEmpleado,
  listarPuestos,
};
export default empleadosService;
